// API Configuration

export const API_CONFIG = {
  // Base URLs for different environments
  BASE_URL: {
    development: 'http://localhost:8081/api',
    staging: '/api',
    production: '/api'
  },

  // API Endpoints
  ENDPOINTS: {

    // Auth endpoints
    AUTH: {
      LOGIN: '/auth/login',
      LOGOUT: '/auth/logout',
      REGISTER: '/auth/signup',
      FORGOT_PASSWORD: '/auth/forgot-password',
      RESET_PASSWORD: '/auth/reset-password',
      VERIFY_EMAIL: '/auth/verify-email',
      REFRESH_TOKEN: '/auth/refresh-token',
      CHECK_EMAIL: '/auth/check-email',
    },

    // User endpoints
    USER: {
      PROFILE: '/users/profile',
      UPDATE_PROFILE: '/users/profile/update',
      CHANGE_PASSWORD: '/users/password/change',
    },

    // Transaction endpoints
    TRANSACTIONS: {
      LIST: '/transactions',
      CREATE: '/transactions',
      UPDATE: '/transactions/:id',
      DELETE: '/transactions/:id',
    },

    // Account endpoints
    ACCOUNTS: {
      LIST: '/accounts',
      CREATE: '/accounts',
      UPDATE: '/accounts/:id',
      DELETE: '/accounts/:id',
    },

    // Reports endpoints
    REPORTS: {
      GENERATE: '/reports/generate',
      DOWNLOAD: '/reports/download/:id',
    },
  },

  TIMEOUT: 30000,

  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
};


// Environment Detection
export const getCurrentEnvironment = (): 'development' | 'staging' | 'production' => {
  return (import.meta.env.MODE as 'development' | 'staging' | 'production') || 'development';
};


// Base URL Resolver
export const getBaseUrl = (): string => {
  const env = getCurrentEnvironment();
  return API_CONFIG.BASE_URL[env];
};